var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Indicator",style:({opacity: _vm.opacity})},[_c('div',{staticClass:"Indicator-bar",style:({width: _vm.progress + '%', backgroundColor: _vm.setProps('color')})})])}
var staticRenderFns = []

export { render, staticRenderFns }